import Axios from 'axios';
import Qs from 'qs';

export default {

  // 报修项目分页列表
  listPage(
    repair_item_service_name,
    repair_item_type,
    repair_item_id,
    page,
    per_page
  ) {
    return Axios.get('/wybx/api/admin/repair_item_service', {
      params: {
        repair_item_service_name,
        repair_item_type,
        repair_item_id,
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },

  // 报修项目上线
  online(
    id
  ) {
    return Axios.post(`/wybx/api/admin/repair_item_service/online/${id}`);
  },

  // 报修项目下线
  offline(
    id
  ) {
    return Axios.post(`/wybx/api/admin/repair_item_service/offline/${id}`);
  },

  // 报修项目新增
  add(
    repair_item_service_name,
    repair_item_id,
    repair_item_price,
    repair_item_unit,
    repair_item_attachment_id,
    repair_item_service_desc
  ) {
    return Axios.post('/wybx/api/admin/repair_item_service', {
      repair_item_service_name,
      repair_item_id,
      repair_item_price,
      repair_item_unit,
      repair_item_attachment_id,
      repair_item_service_desc
    });
  },

  // 报修项目编辑
  edit(
    id,
    repair_item_service_name,
    repair_item_id,
    repair_item_price,
    repair_item_unit,
    repair_item_attachment_id,
    repair_item_service_desc
  ) {
    return Axios.put(`/wybx/api/admin/repair_item_service/${id}`, {
      repair_item_service_name,
      repair_item_id,
      repair_item_price,
      repair_item_unit,
      repair_item_attachment_id,
      repair_item_service_desc
    });
  },

  // 报修项目详情
  info(
    id
  ) {
    return Axios.get(`/wybx/api/admin/repair_item_service/${id}`);
  }

}